import { render, staticRenderFns } from "./success-component.vue?vue&type=template&id=e2073c1c&lang=html"
import script from "./success-component.vue?vue&type=script&lang=js"
export * from "./success-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports